module.exports = __webpack_public_path__ + "static/img/female-bg-ar.7ab00596.png";